<template>
	<div style="width:560; height:315; position: relative;">
		<video
			v-if="isYoutube"
			class="video-js vjs-big-play-centered vjs-default-skin disablePictureInPicture"
			controls
			:autoplay = false
			fluid="true"
			preload="auto"
			ref="videoPlayer"
			style="border-radius: 25px;"
		>
		<!-- :data-setup="options.data" -->
		</video>
		<video v-if="!isYoutube" ref="videoPlayer" class="video-js vjs-big-play-centered"></video>
	</div>
</template>

<script>
	import videojs from 'video.js';
	import videojsyoutube from 'videojs-youtube';
	export default {
		name: "VideoPlayer",
		props: {
			options: {
				type: Object,
				default() {
					return {};
				}
			},
			isYoutube: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				player: null,
				isTakingScreenshot: false,
				
			}
		},
		mounted() {
			this.player = videojs(this.$refs.videoPlayer, this.$props.options, function onPlayerReady() {})
			
			const self = this;
			this.player.on('timeupdate', function() {
				if (self.isTakingScreenshot) {
					self.isTakingScreenshot = false;
				}
			});

			window.addEventListener('keyup', this.handleKeyUp);
			window.addEventListener('keydown', this.handleKeyDownMac);
		},
		beforeDestroy() {
			if (this.player) {
				this.player.dispose()
			}
		},
		methods: {
			takeScreenshot() {
				this.isTakingScreenshot = true;
			},
			handleKeyUp(event){
				if (event.keyCode === 44 || (event.metaKey && (event.key === "3" || event.key === "4"))) {
					this.takeScreenshot();
				}
			},
			handleKeyDownMac(e){
				if (e.metaKey && (e.key === "3" || e.key === "4")) {
					this.takeScreenshot();
				}
			}

		}
	}
</script>

<style lang="scss" scoped>
	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, );
		display: flex;
		justify-content: center;
		align-items: center;
		color: white;
		font-size: 24px;
	}

	.video-js{
		background: transparent !important;
	}

</style>